import { useMutation, useQueryClient } from "@tanstack/react-query";

function normalizeInvalidateQueryKeys(invalidateQueryKeys) {
    if (!Array.isArray(invalidateQueryKeys)) {
        return [];
    }

    return invalidateQueryKeys.filter((queryKey) => queryKey !== undefined && queryKey !== null);
}

function buildMutationKey(mutationKey, mutationKeyPrefix, route) {
    if (mutationKey !== undefined) {
        return mutationKey;
    }

    const hasRoute = typeof route === "string" && route.length > 0;
    return hasRoute ? [mutationKeyPrefix, route] : [mutationKeyPrefix];
}

export function useApiMutation({ route, request, mutationKeyPrefix, options = {} }) {
    const queryClient = useQueryClient();
    const {
        mutationFn,
        mutationKey,
        invalidateQueryKeys = [],
        onSuccess,
        ...mutationOptions
    } = options;

    return useMutation({
        mutationKey: buildMutationKey(mutationKey, mutationKeyPrefix, route),
        mutationFn: mutationFn ?? ((params) => request(route, params)),
        onSuccess: async (data, variables, context) => {
            const queryKeys = normalizeInvalidateQueryKeys(invalidateQueryKeys);

            if (queryKeys.length > 0) {
                await Promise.all(
                    queryKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey }))
                );
            }

            if (onSuccess) {
                return onSuccess(data, variables, context);
            }

            return undefined;
        },
        ...mutationOptions,
    });
}
